import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbAccordionModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { UploadsModule } from '@progress/kendo-angular-upload';
import { TranslateModule } from '@ngx-translate/core';
import { DataImportConfigurationComponent } from './data-import-configuration/data-import-configuration.component';
import { DataImportLogsComponent } from './data-import-logs/data-import-logs.component';
import { DataImportRoutingModule } from './data-import-routing.module';
import { DataImportSelectionComponent } from './data-import-selection/data-import-selection.component';
import { DataImportComponent } from './data-import.component';
import { DataImportLogEffects } from './state/data-import-logs.effects';
import { dataImportLogStateReducer } from './state/data-import-logs.reducer';


@NgModule({
  declarations: [DataImportComponent,
    DataImportLogsComponent,
    DataImportConfigurationComponent,
    DataImportSelectionComponent],
  imports: [
    CommonModule,
    DataImportRoutingModule,
    FormsModule,
    InputsModule,
    ReactiveFormsModule,
    NgbAccordionModule,
    NgbModule,
    UploadsModule,
    StoreModule.forFeature('dataImportLogs', dataImportLogStateReducer),
    EffectsModule.forFeature([DataImportLogEffects]),
    TranslateModule
  ],
  exports:[TranslateModule, DataImportComponent, DataImportLogsComponent, DataImportConfigurationComponent, DataImportSelectionComponent],
})
export class DataImportModule { }
